module.exports = __webpack_public_path__ + "static/media/gh.cc4d2851.svg";